module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-d7475c568efef2a71ec02691b2c8dab4.png";